require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
module.exports = require('../modules/$.core').Set;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es6/set.js
// module id = 151
// module chunks = 0